import moment from "moment";
import { BiChevronRight } from "react-icons/bi";
import { ProtocolsIcon, WorkoutsIcon } from "src/assets/static/icons";
import { twMerge } from "tailwind-merge";
import { LPItem } from "../interfaces";

/**
 * Componente que exibe um item da lista de Planos
 */
interface PlanItemProps {
  plan: LPItem;
  index: number;
  isExpanded: boolean;
  isSelected: boolean;
  currentWorkout: string | undefined;
  onToggleExpand: () => void;
  onSelectPlan: () => void;
  onSelectWorkout: (plan: string, workout: string) => void;
}

const PlanItem: React.FC<PlanItemProps> = ({
  plan,
  index,
  isExpanded,
  isSelected,
  currentWorkout,
  onToggleExpand,
  onSelectPlan,
  onSelectWorkout,
}) => {
  return (
    <li
      className={twMerge(
        "mb-2 flex flex-col items-center rounded border border-zinc-200 bg-white transition hover:shadow-sm dark:border-zinc-700 dark:bg-zinc-900",
        isSelected && "border-black dark:border-white",
      )}
      data-id={plan.id}
    >
      <div className="flex w-full items-center p-2">
        {/* Botão de Expandir */}
        <button
          data-index={index}
          onClick={onToggleExpand}
          className="mr-2 rounded-full p-1 transition hover:bg-zinc-300 dark:hover:bg-zinc-700"
          aria-label="Expandir"
        >
          <BiChevronRight
            size={20}
            className={`transform text-zinc-700 transition-transform dark:text-zinc-200 ${
              isExpanded ? "rotate-90" : ""
            }`}
          />
        </button>

        {/* Informações do Plano */}
        <div
          onClick={onSelectPlan}
          className="flex flex-1 cursor-pointer flex-col overflow-hidden"
        >
          <div className="flex shrink-0 items-center gap-2 overflow-ellipsis whitespace-nowrap">
            <ProtocolsIcon className="shrink-0 dark:text-white" />
            <p className="text-sm font-bold text-zinc-900 dark:text-zinc-100">
              {plan.title}
            </p>
          </div>
          <p className="text-xs text-zinc-500 dark:text-zinc-400">
            {moment(plan.modified).format("LLL")}
          </p>
        </div>
      </div>

      {/* Lista de Treinos */}
      {isExpanded && (
        <div className={twMerge("flex w-full flex-col p-2")}>
          {plan.workouts.map((workout) => (
            <button
              key={`${plan.id}-${workout.id}_key`}
              className={twMerge(
                "flex w-full items-center justify-between rounded border border-transparent p-1 transition hover:bg-zinc-100 dark:hover:bg-zinc-800",
                currentWorkout === workout.id &&
                  "border-black dark:border-white",
              )}
              onClick={onSelectWorkout.bind(null, plan.id, workout.id)}
            >
              <div className="flex items-center gap-2">
                <WorkoutsIcon color="#777" />
                <p className="text-sm text-zinc-900 dark:text-zinc-100">
                  {workout.title}
                </p>
              </div>
              <BiChevronRight
                size={12}
                className="text-zinc-700 dark:text-zinc-200"
              />
            </button>
          ))}
        </div>
      )}
    </li>
  );
};

export default PlanItem;
